import * as React from "react";
import {
  ISharedAppContext,
  ISharedAppContextV2,
  SharedAppConsumer,
  SharedAppContextV2Consumer,
  SharedAppContextV2Provider,
  SharedAppProvider
} from "@origin-digital/shared-app-context";
import { hasScopedJwt, auth0EnvConfigs } from "@origin-digital/origin-auth";
import { isLocalEnvironment } from "../../auth/jwtUtils";
import { initFeatures, getOriginCustomerId } from "./sacToggleHelpers";

interface ISacVersionToggleProps {
  initSAC: boolean;
  authenticated: boolean;
  children: (context: ISharedAppContext | ISharedAppContextV2) => JSX.Element;
}

interface ISacVersionToggleState {
  isSacV2User: boolean;
  originCustomerId?: string;
}

export class SacVersionToggle extends React.Component<
  ISacVersionToggleProps,
  ISacVersionToggleState
> {
  constructor(props) {
    super(props);
    this.state = {
      isSacV2User: this.hasScopedJwt()
    };
  }

  private hasScopedJwt = (): boolean => {
    return (
      typeof window !== "undefined" &&
      this.props.authenticated &&
      hasScopedJwt(auth0EnvConfigs[window.oetal.env.name])
    );
  };

  private useSacV2IfToggledCustomer = async () => {
    if (typeof window !== "undefined" && !isLocalEnvironment()) {
      let originCustomerId = await getOriginCustomerId();
      if (!originCustomerId) {
        // dont set up features if no origin customer id
        return;
      }
      this.setState({
        originCustomerId
      });
    }
    initFeatures(this.state.originCustomerId, featureEnabled => {
      const isSacV2User = featureEnabled;
      this.setState({ isSacV2User });
    });
  };

  async componentDidMount() {
    // sac v2 and accompanying feature switch is only attempted for authenticated apps
    if (this.props.authenticated && !this.state.isSacV2User) {
      await this.useSacV2IfToggledCustomer();
    }
  }

  render() {
    const { isSacV2User } = this.state;
    const { initSAC, children } = this.props;

    const SacProvider = isSacV2User
      ? SharedAppContextV2Provider
      : SharedAppProvider;

    const SacConsumer = isSacV2User
      ? SharedAppContextV2Consumer
      : SharedAppConsumer;

    return (
      <SacProvider
        xhrHost={__DEV__ ? "http://localhost:4488" : undefined}
        xhrInitialize={initSAC}
      >
        <SacConsumer>{children}</SacConsumer>
      </SacProvider>
    );
  }
}
